import { Component, Input } from '@angular/core';

@Component({
  selector: 'icc-sort-order-icon',
  templateUrl: './sort-order-icon.component.html',
  styleUrls: ['./sort-order-icon.component.scss']
})
export class SortOrderIconComponent {

  @Input() sort: {
    order: 'asc' | 'desc' | null;
    index: number;
  };

}
